export default __webpack_public_path__ + "static/media/login-page-img.5bf434a2.png";